(function () {
    'use strict';
    angular.module('mean.accounting').filter('dateRange', function () {
        return function (items, startDate, endDate) {
            if(!startDate && !endDate) return items;
            var retArray = [];

            if (!startDate && !endDate) {
                return items;
            }
            angular.forEach(items, function (obj) {
                var receivedDate = obj.date;
                if (moment(receivedDate).isAfter(startDate) && moment(receivedDate).isBefore(endDate)) {
                    retArray.push(obj);
                }
            });

            return retArray;

        }
    })
})();


// WEBPACK FOOTER //
// ./packages/custom/accounting/public/directives/daterange-filter.js